<template>
  <el-main class="main">
    <div class="flex">
      <studentList
        @select="getstu1"
        url="/enterpise/students/finished"
        :enterpise="true"
      />
      <div class="neirong">
        <div class="jtitle">
          <h2 class="jtext">结项学员</h2>
        </div>
        <projectInfo :project="activeProject">
          <div slot="roles" class="rolesIcon">
            <el-tooltip effect="light" content="规划师" placement="top">
              <img src="../../assets/roles/icon/规划师.png" />
            </el-tooltip>
            <span>{{ activeProject.planner }}</span>
            <el-tooltip effect="light" content="客户经理" placement="top">
              <img src="../../assets/roles/icon/客户经理.png" />
            </el-tooltip>
            <span>{{ activeProject.amanager }}</span>
            <el-tooltip effect="light" content="渠道经理" placement="top">
              <img src="../../assets/roles/icon/渠道经理.png" />
            </el-tooltip>
            <span>{{ activeProject.cmanager }}</span>
          </div>
          <div slot="buttons">
            <final-button :pid="pid"></final-button>
            <el-button
              type="primary"
              @click="exportI = true"
              size="mini"
              class="el-icon-download"
              style="font-size: 22px"
            >
            </el-button>
          </div>
          <div slot="stages">
            <div v-if="filegroups_output.length > 0" class="output">
              <div class="outtitle">
                项目产出：
              </div>
              <div class="outcontent">
                <div
                  class="outdoc"
                  v-for="out in filegroups_output"
                  :key="out.id"
                >
                  <a href="javascript:void(0);" @click="download(out.url,out.name)">{{ out.name }}</a>
                  <span>({{ Math.ceil(out.size / 1024) }}KB)</span>
                </div>
              </div>
            </div>
            <stages
              :tableData="tableData"
              :project="activeProject"
              :interview="interview"
              :enterpise="true"
            ></stages>
          </div>
        </projectInfo>
      </div>
    </div>
    <export-img
      v-if="exportI"
      :smes="smes"
      :tableData="tableData"
      :project="activeProject"
      :interview="interview"
      :isEnterprise="true"
    ></export-img>
  </el-main>
</template>

<script>
import axios from '../axios'
import studentList from '../pub/studentList'
import projectInfo from '../pub/projectInfo'
import stages from '../pub/stages'
import informationButton from '../pub/buttons/informationButton'
import finalButton from '../pub/buttons/finalButton'
import exportImg from '../pub/exportImg'
import suggestRead from '../pub/suggestRead'
export default {
  name: 'Estudent',
  components: {
    studentList,
    projectInfo,
    stages,
    exportImg,
    finalButton,
    informationButton,
    suggestRead
  },
  data () {
    return {
      smes: {
        name: '',
        school: '',
        cellphone: '',
        email: '',
        direction: '',
        sex: ''
      },
      tableData: [],
      options: ['学员', '渠道', '规划师', '项目', '方向'],
      interview: {},
      project_type: '',
      teacher: '',
      pid: 0,
      activeProject: {},
      filegroups_abfeed: [],
      filegroups_output: [],
      filegroups_feed: [],
      filegroups_nosign: [],
      exportI: false
    }
  },
  methods: {
    getstu1 (pid = false) {
      let id = 0
      if (pid) {
        id = pid
      } else {
        id = this.pid
      }
      axios
        .get(`/${this.$store.state.roleApi}/project/${id}/`)
        .then(response => {
          this.project_type = response.data.project.project_type
          this.pid = response.data.project.id
          this.tableData = response.data.stages
          this.filegroups_output = response.data.project.filegroups_output
          this.activeProject = response.data.project
          this.smes = response.data.student
        })
        .catch(error => {
          console.log(error)
        })
    },
    download (fileUrl,name) {
      let x = new XMLHttpRequest()
      x.open('GET', fileUrl, true)
      x.responseType = 'blob'
      x.onload = function (e) {
        let url = window.URL.createObjectURL(x.response)
        let a = document.createElement('a')
        a.href = url
        a.download = name
        a.click()
      }
      x.send()
    }
  }
}
</script>
